/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import { updateRegisterStep } from 'models/user';

const EmailVerifySuccess = ({ t, router, userState }) => {
  useEffect(() => {
    updateRegisterStep(router.query?.userToken);
  }, []);

  return (
    <div className="col-md-10 col-lg-8 offset-lg-1 mt-5 mt-lg-0">
      <div className="mb-5">
        <div className="row">
          <div className="col">
            <div className="row mb-4">
              <div className="col text-center">
                <i className="fa-solid fa-check-circle text-green2 fs-90" />
              </div>
            </div>
            <div className="row mb-4">
              <div className="col text-center">
                <div className="fs-22 fw-700">E-posta aktivasyonu başarıyla tamamlanmıştır.</div>
              </div>
            </div>
          </div>
        </div>
        <div className="col mt-3">
          <a
            className="im-button im-button--primary im-button--fluid im-button--center fw-900"
            onClick={() => {
              router.push({
                pathname: '/register/phone-enterence',
                query: {
                  id: userState.id,
                },
              });
            }}
          >
            {t('next')}
          </a>
        </div>

      </div>
    </div>
  );
};

EmailVerifySuccess.propTypes = {
  t: PropTypes.func,
  router: PropTypes.object,
  userState: PropTypes.object,
};

export default withTranslation('common')(EmailVerifySuccess);
